import Vue from 'vue'
import Router from 'vue-router'
const login = () => import('@/views/login/login')
const Home = () => import('@/views/home/Home')
const CaseManagements = () => import('@/views/caseManagement/CaseManagements')
const CaseDetails = () => import('@/views/caseManagement/CaseDetails')
const NewsManage = () => import('@/views/newsManage/NewsManage')
const HonoraryManage = () => import('@/views/honoraryManage/honoraryManage')
const addCase = () => import('@/views/caseManagement/addCase')
const editCase = () => import('@/views/caseManagement/editCase')
const informationCenter = () => import('@/views/caseManagement/informationCenter')
const editConsulte = () => import('@/views/caseManagement/editConsulte')
const addConsulte = () => import('@/views/caseManagement/addConsulte')
const bannerManage = () => import('@/views/bannerManage/bannerManage')
const editBanner = () => import('@/views/bannerManage/editBanner')
const addBanner = () => import('@/views/bannerManage/addBanner')
import Cookies from "js-cookie";
Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [{
      path: '/login',
      name: 'Login',
      component: login,
      meta: {
        title: '官网管控台'
      }
    },
    {
      path: '/home',
      name: '当前位置',
      component: Home,
      children: [{
          path: '/caseManagement',
          name: '客户案例管理',
          component: r => require.ensure([], () => r(require('@/views/caseManagement/index')), 'CaseManagement'),
          children: [{
              path: '/',
              name: '案例分类',
              component: r => require.ensure([], () => r(require('@/views/caseManagement/index')), 'CaseManagement'),
              meta: {
                title: '案例分类'
              },
              redirect: '/caseManagements',
              // children: [{
              //     path: '/CaseManagement/addCase',
              //     name: '添加案例',
              //     component: addCase,
              //     meta: {
              //       title: '添加案例'
              //     }
              //   },
              //   {
              //     path: '/CaseManagement/editCase',
              //     name: '添加案例',
              //     component: editCase,
              //     meta: {
              //       title: '添加案例'
              //     }
              //   }
              // ]
            },
            {
              path: '/caseManagements',
              name: '案例分类',
              component: CaseManagements,
              meta: {
                title: '案例分类'
              }
            },
            {
              path: '/CaseDetail',
              name: '案例详情',
              component: r => require.ensure([], () => r(require('@/views/caseManagement/index')), 'CaseDetail'),
              meta: {
                title: '案例详情'
              },
              redirect: '/CaseDetails',
              // children: [{
              //     path: '/CaseDetail/addConsulte',
              //     name: '成员管理',
              //     component: addConsulte,
              //     meta: {
              //       title: '成员管理'
              //     }
              //   },
              //   {
              //     path: '/CaseDetail/editConsulte',
              //     name: '成员管理',
              //     component: editConsulte,
              //     meta: {
              //       title: '成员管理'
              //     }
              //   }
              // ]
            },
            {
              path: '/caseDetails',
              name: '案例详情',
              component: CaseDetails,
              meta: {
                title: '案例详情'
              }
            },

          ],
        },
        {
          path: '/bannerManages',
          name: 'banner管理',
          component: bannerManage,
          meta: {
            title: 'banner管理'
          },
          children: [],
        },
        {
          path: '/bannerManage',
          name: 'banner管理',
          component: r => require.ensure([], () => r(require('@/views/bannerManage/index')), 'bannerManage'),
          meta: {
            title: 'banner管理'
          },
          redirect: '/bannerManages',
          children: [{
              path: '/bannerManage/editBanner',
              name: '编辑',
              component: editBanner,
              meta: {
                title: '编辑'
              }
            },
            {
              path: '/bannerManage/addBanner',
              name: '添加',
              component: addBanner,
              meta: {
                title: '添加'
              }
            },
          ],
        },
        {
          path: '/newsManages',
          name: '新闻资讯管理',
          component: NewsManage,
          meta: {
            title: '新闻资讯管理'
          },
          children: [],
        },
        {
          path: '/newsManage',
          name: '新闻资讯管理',
          component: r => require.ensure([], () => r(require('@/views/newsManage/index')), 'NewsManage'),
          meta: {
            title: '新闻资讯管理'
          },
          redirect: '/newsManages',
          children: [{
              path: '/newsManage/addConsulte',
              name: '添加新闻资讯',
              component: addConsulte,
              meta: {
                title: '添加新闻资讯'
              }
            },
            {
              path: '/newsManage/editConsulte',
              name: '编辑新闻资讯',
              component: editConsulte,
              meta: {
                title: '编辑新闻资讯'
              }
            }
          ]
        },
        {
          path: '/honoraryManages',
          name: '荣誉资质管理',
          component: HonoraryManage,
          meta: {
            title: '荣誉资质管理'
          },
          children: [],
        },
        {
          path: '/honoraryManage',
          name: '荣誉资质管理',
          component: r => require.ensure([], () => r(require('@/views/honoraryManage/index')), 'HonoraryManage'),
          meta: {
            title: '荣誉资质管理'
          },
          redirect: '/honoraryManages'
        },
      ]
    },
  ]
})
router.beforeEach((to, from, next) => {
  const token = Cookies.get('token')
  if (token) {
    if (to.path == '/') {
      next('/login')

    } else {
      next()
    }
  } else {
    if (to.path == '/login') {
      next()
    } else {
      next('/login')
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js